import React from 'react';

import { EmptyData } from './EmptyData';
import { EmptyState } from './EmptyState';

export const Empty = () => {
  return null;
};

Empty.State = EmptyState;
Empty.Data = EmptyData;
